<nz-alert
                    
  [nzType]="nzType"
  [nzMessage]="messageTmpl"
  [nzDescription]="description ? descTmpl : null"
  nzShowIcon
  [class]="btClass"
></nz-alert>
<ng-template #messageTmpl>
  <div [innerHTML]="message | actrans"></div>
</ng-template>
<ng-template #descTmpl>
  <div [innerHTML]="description | actrans"></div>
</ng-template>

